<template>
  <div class="cabecalho">
    <div class="row">
      <div class="col-md-10">
        <div class="titulo">{{ pageTitles.title }}</div>
        <template v-if="pageTitles.subtitle">
          <div class="subTitulo">{{ pageTitles.subtitle }}.</div>
        </template>
      </div>
      <div class="col-md-2 d-flex justify-content-end align-items-start cadastra">
        <template v-if="!hideButton">
          <button v-if="formOpen" class="btn btn-noticia" @click="onClick">
            <span>Lista</span>
          </button>
          <button v-else class="btn btn-noticia" @click="onClick" :style="isRegisterPermission == null || isRegisterPermission ? 'display:block;' : 'display:none;'">
            <span>Cadastro</span>
          </button>          
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="borda"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pageTitles', 'formOpen', 'hideButton', 'isRegisterPermission'],
  data() {
    return {}
  },
  methods: {
      onClick(){
          this.$emit('onClick')
      }
  }
}
</script>

<style lang="scss" scoped>
   .cabecalho {
       .titulo {
        font-size: 25px;
        color: #113D63;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .subtitulo {
        margin-bottom: 10px;
      }

      .btn-noticia {
        //margin-top: 30px;
        //margin-bottom: 10px;
        background-color: #113D63;
        padding: 5px 30px;
        
        &.botaoTopo {
            float: right;
        }
      }

   }
</style>